module.exports = __webpack_public_path__ + "imgs/instagram-white.83b25fecd19edd918cd2c4eb447697b1.svg";